import React from 'react';
import type { RegisteredMember } from '../../types/member';
import PersonalInfo from './PersonalInfo';
import FamilyInfo from './FamilyInfo';
import DiscipleshipStatus from './DiscipleshipStatus';

interface PrintableReportProps {
  member: RegisteredMember;
}

const PrintableReport: React.FC<PrintableReportProps> = ({ member }) => {
  return (
    <div className="only-print">
      <div className="print-header">
        <div className="w-24 h-24 bg-gray-300 rounded-full mr-6 flex-shrink-0"></div>
        <div>
          <h1 className="text-3xl font-bold">{member.name}</h1>
          <p className="text-lg text-gray-600">{member.position || '성도'}</p>
          <p className="text-md text-gray-500 mt-1">{member.cellGroup || '소속 없음'}</p>
        </div>
      </div>
      <div className="printable-content">
        <PersonalInfo member={member} />
        <FamilyInfo memberId={member.id} />
        <DiscipleshipStatus memberId={member.id} />
      </div>
    </div>
  );
};

export default PrintableReport;
